var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tableSort pointer"},[_c('span',{on:{"click":_vm.clickSort}},[_vm._v(_vm._s(_vm.sortText))]),_c('i',{ref:"ascending",staticClass:"tableSort-top",on:{"click":_vm.ascending}}),_c('i',{ref:"descending",staticClass:"tableSort-bottom",on:{"click":_vm.descending}})])
}
var staticRenderFns = []

export { render, staticRenderFns }